import ConditionalVisibility from './ConditionalVisibility.vue';

const components = [ConditionalVisibility];

function install(Vue) {
  components.forEach(component => {
    Vue.component(component.name, component);
  });
}

export default {
  install
};
